// NOTE: This is a temporary wrapper file to allow use of the HomeApplications React component in ERB files
import React from 'react'
import HomeApplications from '../../components/views/home/HomeApplications'

const ErbFHomeApplications: React.FC<{}> = () => {
  return <HomeApplications />
}

export default ErbFHomeApplications
